import React, { useState, useEffect } from 'react'
import DropDown from '~/Common-Objects/UI/DropDowns/DropDown'
import Icons from '~/Common-Objects/UI/Icons/index'
import axios from '~/data/http/axios'
import Rum from '../../../../Classes/rum'
import i18n from '~/i18n'
const apps = [{
    name: 'Capsule',
    labelKey: 'nav:appSwitcher.crm',
    icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8009_3829)">
            <path d="M32 0H0V32H32V0Z" fill="#453DD8" />
            <path d="M18.121 8.45206C17.8223 8.45206 17.5791 8.69766 17.5791 8.99934C17.5791 9.3011 17.8223 9.5467 18.121 9.5467C18.4197 9.5467 18.6629 9.3011 18.6629 8.99934C18.6629 8.69766 18.4197 8.45206 18.121 8.45206Z" fill="white" />
            <path d="M18.121 10.9745C17.8223 10.9745 17.5791 11.2201 17.5791 11.5219C17.5791 11.8236 17.8223 12.0692 18.121 12.0692C18.4197 12.0692 18.6629 11.8236 18.6629 11.5219C18.6629 11.2201 18.4197 10.9745 18.121 10.9745Z" fill="white" />
            <path d="M18.121 13.4969C17.8223 13.4969 17.5791 13.7424 17.5791 14.0442C17.5791 14.346 17.8223 14.5915 18.121 14.5915C18.4197 14.5915 18.6629 14.346 18.6629 14.0442C18.6629 13.7424 18.4197 13.4969 18.121 13.4969Z" fill="white" />
            <path d="M20.6678 8.45206C20.3691 8.45206 20.126 8.69766 20.126 8.99934C20.126 9.3011 20.3691 9.5467 20.6678 9.5467C20.9666 9.5467 21.2097 9.3011 21.2097 8.99934C21.2097 8.69766 20.9666 8.45206 20.6678 8.45206Z" fill="white" />
            <path d="M20.6681 10.9745C20.3693 10.9745 20.1262 11.2201 20.1262 11.5219C20.1262 11.8236 20.3693 12.0692 20.6681 12.0692C20.9669 12.0692 21.21 11.8236 21.21 11.5219C21.21 11.2201 20.9669 10.9745 20.6681 10.9745Z" fill="white" />
            <path d="M20.6681 13.4969C20.3693 13.4969 20.1262 13.7424 20.1262 14.0442C20.1262 14.346 20.3693 14.5915 20.6681 14.5915C20.9669 14.5915 21.21 14.346 21.21 14.0442C21.21 13.7424 20.9669 13.4969 20.6681 13.4969Z" fill="white" />
            <path d="M23.1696 8.45206C22.8709 8.45206 22.6277 8.69766 22.6277 8.99934C22.6277 9.3011 22.8709 9.5467 23.1696 9.5467C23.4683 9.5467 23.7115 9.3011 23.7115 8.99934C23.715 8.69766 23.4718 8.45206 23.1696 8.45206Z" fill="white" />
            <path d="M23.1698 10.9745C22.8711 10.9745 22.6279 11.2201 22.6279 11.5219C22.6279 11.8236 22.8711 12.0692 23.1698 12.0692C23.4686 12.0692 23.7118 11.8236 23.7118 11.5219C23.7152 11.2201 23.4721 10.9745 23.1698 10.9745Z" fill="white" />
            <path d="M23.1698 13.4969C22.8711 13.4969 22.6279 13.7424 22.6279 14.0442C22.6279 14.346 22.8711 14.5915 23.1698 14.5915C23.4686 14.5915 23.7118 14.346 23.7118 14.0442C23.7118 13.7424 23.4721 13.4969 23.1698 13.4969Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99976 11.5061C7.99976 9.75382 9.42021 8.33334 11.1725 8.33334C12.9248 8.33334 14.3453 9.75382 14.3453 11.5061V20.3312C14.3453 22.0834 12.9248 23.5039 11.1725 23.5039C9.42021 23.5039 7.99976 22.0834 7.99976 20.3312V11.5061ZM8.90693 20.2317C8.93613 18.9633 9.97541 17.9585 11.226 17.988C12.4789 18.0175 13.4697 19.0717 13.4381 20.3401C13.4089 21.6085 12.3697 22.6134 11.1191 22.5838C9.86853 22.5543 8.87781 21.5001 8.90693 20.2317ZM10.4163 21.1084H11.9315V19.5715H10.4163V21.1084ZM11.2743 9.30846C12.5255 9.33918 13.5169 10.3929 13.4887 11.6621C13.4605 12.9313 12.4232 13.9352 11.1719 13.9045C9.92069 13.8737 8.92925 12.8199 8.95749 11.5508C8.98573 10.2816 10.023 9.27766 11.2743 9.30846Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3198 16.92V23.6666H23.9998V16.92H17.3198ZM22.6426 21.8141H18.679V20.9792H22.6426V21.8141ZM18.679 19.604H22.6426V18.769H18.679V19.604Z" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_8009_3829">
                <rect width="32" height="32" rx="10" fill="white" />
            </clipPath>
        </defs>
    </svg>
}, {
    name: 'Transpond',
    labelKey: 'nav:appSwitcher.marketing',
    icon: <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="10" fill="black" />
        <path d="M13.0319 7.66667L10.1354 9.33333L7.25 7.66667L10.1354 6L13.0319 7.66667Z" fill="white" />
        <path d="M15.9283 9.33323L13.0318 10.9999L10.1353 9.33323L13.0318 7.66656L15.9283 9.33323Z" fill="white" />
        <path d="M18.825 11L15.9285 12.6666L13.032 11L15.9285 9.33331L18.825 11Z" fill="white" />
        <path d="M21.7217 12.6667L18.8252 14.3333L15.9287 12.6667L18.8252 11L21.7217 12.6667Z" fill="white" />
        <path d="M24.6058 14.3333L21.7205 15.9999L18.824 14.3333L21.7205 12.6666L24.6058 14.3333Z" fill="white" />
        <path d="M18.8252 17.6666V20.9999L15.9287 22.6666V19.3333L18.8252 17.6666Z" fill="white" />
        <path d="M24.6068 14.3334V17.6667L21.7214 19.3334V16L24.6068 14.3334Z" fill="white" />
        <path d="M13.0318 21V24.3333L10.1353 26V22.6667L13.0318 21Z" fill="white" />
        <path d="M13.0319 14.3333L10.1354 16L7.25 14.3333L10.1354 12.6666L13.0319 14.3333Z" fill="white" />
        <path d="M15.9283 16.0001L13.0318 17.6667L10.1353 16.0001L13.0318 14.3334L15.9283 16.0001Z" fill="white" />
        <path d="M18.825 17.6667L15.9285 19.3333L13.032 17.6667L15.9285 16L18.825 17.6667Z" fill="white" />
        <path d="M10.1354 6V9.33333L7.25 11V7.66667L10.1354 6Z" fill="white" />
        <path d="M10.1354 12.6666V16L7.25 17.6666V14.3333L10.1354 12.6666Z" fill="white" />
        <path d="M13.0319 21L10.1354 22.6666L7.25 21L10.1354 19.3333L13.0319 21Z" fill="white" />
        <path d="M10.1354 19.3333V22.6666L7.25 24.3333V21L10.1354 19.3333Z" fill="white" />
    </svg>

}]


export default function AppSwitcher({ }) {
    const [capsule, setCapsule] = useState(null)
    const [dropdownOpen, setDropdownOpen] = useState(false)

    useEffect(() => {
        axios.get('/application/account').then(res => {
            setCapsule(res.data.Applications.find(a => a.ApplicationId === 8 && a.active))
        })
    }, [])

    useEffect(() => {
        if (dropdownOpen) {
            Rum.trackEvent('app_switcher_open')
        }
    }, [dropdownOpen])

    const onClick = (appName) => {
        Rum.trackEvent('app_switcher_open_' + appName)
        setDropdownOpen(false)
    }

    if (!capsule?.appSettings?.subdomain) return null

    return (
        <div className="app-switcher">
            <div className="app-switcher-button" onClick={() => setDropdownOpen(!dropdownOpen)}>
                <Icons icon="grid" color="black" />
            </div>
            <DropDown isOpen={dropdownOpen} onClose={() => setDropdownOpen(false)} align="right">
                <div className="app-switcher-menu">
                    {apps.map((app, i) => {
                        let href
                        if (app.name === 'Capsule') href = `https://${capsule.appSettings?.subdomain}.capsulecrm.com`
                        return <a key={i} className="app-switcher-menu-item" href={href} target="_blank" onClick={() => onClick(app.name)}>
                            <div className="app-switcher-menu-item-icon">{app.icon}</div>
                            <div className="app-switcher-menu-item-title">
                                <div>{app.name}</div>
                                <div className="description">{i18n.t(app.labelKey)}</div>
                            </div>
                            {app.name === 'Transpond' && <div className="app-switcher-menu-item-selected">
                                <Icons icon="tick" />
                            </div>}
                        </a>
                    })}
                </div>
            </DropDown>
        </div>
    )
}